module.exports = __webpack_public_path__ + "images/cloud-left.ff462c3a.png";